import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export default function TrackingBar({ variant = "hero", testId = "tracking-bar" }) {
  const [value, setValue] = useState("");
  const nav = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    nav(`/track?tn=${encodeURIComponent(value.trim().toUpperCase())}`);
  };

  const isHero = variant === "hero";
  return (
    <form
      onSubmit={submit}
      data-testid={testId}
      className={`flex flex-col sm:flex-row gap-2 ${isHero ? "bg-white shadow-xl rounded-sm p-3 border border-slate-200" : ""}`}
    >
      <div className="flex-1 flex items-center gap-2 px-4 py-3 bg-white border border-slate-200 rounded-sm focus-within:border-[#1E2A78] focus-within:ring-2 focus-within:ring-[#1E2A78]/30">
        <Search className="h-5 w-5 text-slate-400" />
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Enter tracking number (e.g. AMP2602ABCD1234)"
          className="flex-1 bg-transparent outline-none text-[#0F172A] placeholder:text-slate-400 font-mono text-sm uppercase"
          data-testid="tracking-input"
        />
      </div>
      <button
        type="submit"
        data-testid="tracking-submit"
        className="px-6 py-3 bg-[#FFD700] text-[#1E2A78] font-semibold text-sm rounded-sm hover:bg-[#E6C200] transition-colors uppercase tracking-wider"
      >
        Track Now
      </button>
    </form>
  );
}
